import { Button } from '@/shared/MiButton/MiButton';

interface ActivationButtonProps {
    isActiveTemplate: boolean;
    disabled: boolean;
    onClick: () => void;
}

export const ActivationButton = (props: ActivationButtonProps) => {
    const { isActiveTemplate, disabled, onClick } = props;

    return (
        <Button type={isActiveTemplate ? 'primary' : 'default'} disabled={disabled} onClick={onClick}>
            Применить шаблон
        </Button>
    );
};
